"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=e=>({root:{color:({color:o})=>o?e.palette.common[o]:e.palette.common.gray600}});exports.default=a;
//# sourceMappingURL=styles.js.map
